module.exports = __webpack_public_path__ + "img/bell-ringing-red.5fe6d750.svg";